import EventEmitter from "events";       
export const Emitter = new EventEmitter();